import React, { Suspense } from 'react';
import { shape } from 'prop-types';
import { Provider } from 'react-redux';
import ErrorBoundary from '@components/ErrorBoundary';
import ErrorView from '@components/ErrorView';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router } from 'react-router-dom';
import { hot } from 'react-hot-loader/root';
import configureStore from './store';
import Loader from 'react-loader-spinner'; // You can replace this with your own loader

const RedirectToNativeApp = React.lazy(() =>
  import('./components/LandingPopups/RedirectToNativeApp'),
);
const HowItWorksPopup = React.lazy(() =>
  import('./components/LandingPopups/HowItWorksPopup'),
);
const Routes = React.lazy(() => import('./routes')); // lazy load routes

const initialState = {};
const store = configureStore(initialState);

const App = ({ history }) => (
  <Provider store={store}>
    <ErrorBoundary render={() => <ErrorView />}>
      <HelmetProvider>
        <Router history={history}>
          <Suspense
            fallback={
              <div className="loaderContainer">
                <Loader type="Bars" color="#734385" height={80} width={80} />
              </div>
            }
          >
            {/* Optional condition */}
            {/* {process.env.REACT_APP_ENV === 'prod' && <RedirectToNativeApp />} */}
            {/* <HowItWorksPopup /> */}
            <Routes location={history.location} />
          </Suspense>
        </Router>
      </HelmetProvider>
    </ErrorBoundary>
  </Provider>
);

App.propTypes = {
  history: shape({}).isRequired,
};

export default hot(App);
